import styled from "styled-components";

import {
  DEFAULT_MARGIN_L,
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
} from "@src/common/styles/const";
import { defaultLetterSpacing } from "@src/common/styles/mixins";
import colors from "@src/common/styles/colors";

export const WarningContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${DEFAULT_MARGIN_L}px;

  padding: ${DEFAULT_MARGIN_S}px ${DEFAULT_MARGIN_M}px;
  color: ${colors.gray2};
  border-radius: 12px;
  border: 1px solid ${colors.yellow};

  font-size: 12px;
  font-weight: 600;
  ${defaultLetterSpacing}

  svg {
    flex-shrink: 0;
  }
`;
